// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_content_delivery_bucket": "sqac-amplify-20190817123020-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "https://d3l0j9nusq7n6r.cloudfront.net",
    "aws_cognito_identity_pool_id": "us-west-2:2242a4a9-7ac0-4fbc-ba11-085eb4107ce6",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_vwpoD1O2q",
    "aws_user_pools_web_client_id": "68rmf4v1ve85eicvl8611dl9ul",
    "oauth": {
        "domain": "sqac-dev.auth.us-west-2.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:4200/,https://d3l0j9nusq7n6r.cloudfront.net/",
        "redirectSignOut": "http://localhost:4200/,https://d3l0j9nusq7n6r.cloudfront.net/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "sqac-amplify-user-data-dev",
    "aws_user_files_s3_bucket_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://b4sy46oj3rg3rhyn3hv6xrmzli.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AWS_IAM"
};


export default awsmobile;
